import React from 'react';
import { get } from 'lodash';
import styled from 'styled-components';
import { TextField } from '@material-ui/core';
import { Controller } from "react-hook-form";
import { theme } from '../../../../themes/default-theme';
import Text from '../../../../components/typography';
import isEmail from 'validator/lib/isEmail';
import Checkbox from '../../../../components/forms/Checkbox';
import isPostalCode from 'validator/lib/isPostalCode';

const FormItem = styled.div`
  display: block;
  margin:${props => props.margin === 'none' ? `0` : `0 0 20px`};
  width: 100%;
  text-align: left;

  ${props => props.display === 0 && `
    display: none;
  `}
  label {
    align-items: flex-start;
  }
  input {
    color: #758094;
  }
  span {
    color: #758094;
    padding-top: 0;
    padding-bottom: 0;
  }
  span > a {
    color: #758094;
    padding-top: 0;
    text-decoration: underline;
  }
`

const Error = styled.p`
  color: ${theme.palette.error.form}
`

const YourDetailsTitle = styled.div`
  h2 {
    color: #2E3238;
    font-weight: 800;
    letter-spacing: normal;
  }
  ${theme.breakpoints.up('md')} {
      padding-bottom: 18px;
      h2 {
        font-size: 20px;
        line-height: 24px;
      }
  }
  ${theme.breakpoints.down('sm')} {
    padding-bottom: 13px;
    h2 {
      font-size: 14px;
      line-height: 24px;
    }
  }
  `

const YourDetails = ({ formProps, state, country, title, showPostcode }) => {

    const {
        control,
        errors
    } = formProps

    const textFieldProps = {
        as: TextField,
        control: control,
        rules: { required: true },
        variant: "outlined",
        fullWidth: true,
        defaultValue: ''
    }

    const dealerTitle = process.browser && process.env.DEALER_SITE ? window.staticly.dealerData.name : "{{data.template.dealer.name}}"


    return (
        <>
            {title &&
                <YourDetailsTitle>
                    <Text variant="h2" uppercase align="center">{title}</Text>
                </YourDetailsTitle>
            }
            {/* First name */}
            <FormItem>
                <Controller
                    {...textFieldProps}
                    name={'first_name'}
                    placeholder={'First name*'}
                    error={get(errors, `[first_name]`, false) ? true : false}
                    defaultValue={state.first_name || ''}
                />
                {get(errors, `[first_name]`, false) && <Error>This field is required</Error>}

            </FormItem>
            {/* Last name */}
            <FormItem>
                <Controller
                    {...textFieldProps}
                    name={'last_name'}
                    placeholder={'Last name*'}
                    error={get(errors, `[last_name]`, false) ? true : false}
                    defaultValue={state.last_name || ''}
                />
                {get(errors, `[last_name]`, false) && <Error>This field is required</Error>}
            </FormItem>
            {/* Email */}
            <FormItem>
                <Controller
                    {...textFieldProps}
                    type="email"
                    name={'email'}
                    placeholder={'Email*'}
                    error={get(errors, `[email]`, false) ? true : false}
                    defaultValue={state.email || ''}
                    rules={{
                        required: true,
                        type: 'custom',
                        validate: isEmail
                    }}
                />
                {get(errors, `[email]`, false) && <Error>Please add a valid email address</Error>}
            </FormItem>
            {/* Contact number */}
            <FormItem>
              <Controller
                {...textFieldProps}
                type="tel"
                rules={{
                  ...textFieldProps.rules,
                  type: 'custom',
                  minLength: 8,
                  maxLength: 13
                }}
                name={'phone'}
                placeholder={'Contact number*'}
                error={get(errors, `[phone]`, false) ? true : false}
                defaultValue={state.phone || ''}
              />
              {(get(errors, `[phone]`, false)) && <Error>Please add a 8 digit phone number</Error>}

            </FormItem>
            {/* Postcode */}
            {showPostcode &&
              <FormItem>
                  <Controller
                      {...textFieldProps}
                      type="tel"
                      rules={{
                        ...textFieldProps.rules,
                        type: 'custom',
                        minLength: 3,
                        maxLength: 4,
                        validate: (val) => isPostalCode(val, 'AU')
                      }}
                      name={'customer-postcode'}
                      placeholder={'Postcode*'}
                      error={get(errors, `[customer-postcode]`, false) ? true : false}
                      defaultValue={state.postcode || ''}
                  />
                  {get(errors, `[customer-postcode]`, false) && <Error>Please add a 4 digit postcode</Error>}
              </FormItem>
            }
            {/* Subscribe Newsletter */}
            <FormItem>
                <Controller
                    as={Checkbox}
                    name="newsletter"
                    type="checkbox"
                    control={control}
                    label={`Sign me up for ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} e-Newsletter`}
                    error={get(errors, `[newsletter]`, false) ? true : false}
                    defaultValue={state.newsletter || false}
                    rules={{
                        type: 'custom'
                    }}
                />
            </FormItem>
            {/* Read Privacy policy */}
            <FormItem>
                <Controller
                    as={Checkbox}
                    name="privacy"
                    type="checkbox"
                    control={control}
                    label={`I have read and agree to ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} <br/><a href="/privacy" target="_blank">Privacy Policy</a>*`}
                    error={get(errors, `[privacy]`, false) ? true : false}
                    defaultValue={state.privacy || false}
                    rules={{
                        required: true,
                        type: 'custom'
                    }}
                />
                {get(errors, `[privacy]`, false) && <Error>This field is required</Error>}
            </FormItem>

        </>
    )
}

YourDetails.propTypes = {
}

YourDetails.defaultProps = {
  showPostcode: true
}

export default YourDetails